import { useSlideOver } from "../useSlideOver"
import { useEffect, useState } from "react"
import { ProfileSlideOverSkeleton } from "./shared/ProfileSlideOverSkeleton"
import PracticeProfile from "./practice/PracticeProfile"
import { PublicProfilePractice } from "../../domain/Profile/schema"
import { DataStatus } from "../../domain/enums"
import { useCMSReady } from "../../domain/CMS/useCMSReady"
import appInsightsLogger from "../logging/appInsightsLogger"
import Spinner from "../shared/components/Spinner"

export const PracticeProfileSlideOverContent: React.FC = () => {
  const { showProfileSidebar, getData, dataStatus } = useSlideOver()
  const [profileData, setData] = useState<PublicProfilePractice | undefined>(
    undefined,
  )

  // preload CMS content for profile slide over and child components
  const { isLoading, isReady, hasError } = useCMSReady([
    "common",
    "provider",
    "providerAgesSeen",
    "providerClientEthnicity",
    "providerCommunitiesServedMap",
    "providerDesignationsMap",
    "providerFaithOrientation",
    "providerInsuranceCarriers",
    "providerLanguagesMap",
    "providerParticipant",
    "providerStatusAdjectives",
    "providerSpecialtiesMap",
    "providerTagsMap",
    "providerTherapyTypeMap",
    "publicProfileSlide",
    "referralPacketModal",
    "referrerCodeMap",
    "requestReferralModal",
  ])
  useEffect(() => {
    const getPracticeProfileData = async () => {
      if (!showProfileSidebar.practiceId) {
        return
      }
      const data = await getData({
        practiceId: showProfileSidebar.practiceId,
      })
      setData(data?.practiceProfile)
    }

    getPracticeProfileData()
  }, [getData, showProfileSidebar])

  if (isLoading) {
    return <Spinner />
  } else if (hasError || !isReady) {
    const errorMessage = `PracticeProfileSlideOverContent -- Error loading CMS content`
    appInsightsLogger.traceError(errorMessage)
    throw new Error(errorMessage)
  }

  return (
    <div className="w-full h-screen flex flex-col py-2 overflow-y-auto">
      {dataStatus === DataStatus.LOADING ? (
        <ProfileSlideOverSkeleton />
      ) : (
        <PracticeProfile practiceProfileData={profileData} />
      )}
    </div>
  )
}
